import {useState, useEffect} from 'react';
import {useHistory, useLocation} from "react-router-dom";
import VerificationSignUp from './components/VerificationSignUp';
import Signup from './components/Signup';
import {nToast} from "../../plugins/reactToast";
import {useUserState} from "../../context/UserContext";

const PersonalVerificationPage = () => {
    const [isVerification, setIsVerification] = useState<boolean>(false);
    const location = useLocation();
    const { pathname } = useLocation();
    const query = new URLSearchParams(location.search);
    const history = useHistory();
    const userState = useUserState();

    useEffect(() => {
        if (query.get('niceResultCode') == '0000' && query.get('verifyType') == 'SIGNUP' && !!query.get('tokenVersionId')) {
            setIsVerification(true)
        } else if (!query.get('niceResultCode') && !query.get('verifyType') && !!query.get('tokenVersionId') && !isVerification) {
            history.replace(pathname, undefined);
        }
    }, [query]);

    useEffect(() => {
        const { isLoggedIn } = userState;
        if (isLoggedIn) {
            history.push('/');
            nToast('이미 로그인이 되어있습니다.');
        }
    }, [userState.isLoggedIn]);

    return (
        <>
            <div className={`max-w-md mt-8 md:mx-auto flex flex-col gap-y-8`}>
                <ul className={`grid grid-cols-3 h-0.5 bg-gray-100`}>
                    <li className={`bg_3e52bb ${!isVerification && 'animate-width'}`}></li>
                    <li className={` ${isVerification && 'bg_3e52bb animate-width'}`}></li>
                    <li></li>
                </ul>
                {isVerification ? (
                    <Signup
                        tokenVersionId={query.get('tokenVersionId') ?? ''}
                    />
                ) : (
                    <VerificationSignUp/>
                )}
            </div>
        </>
    );
};

export default PersonalVerificationPage;
